import { createContext, useState, useContext } from 'react';

const SidebarContext = createContext(null);

export const SidebarProvider = ({ children }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);

    const handleMouseEnterSidebar = () => setIsCollapsed(false);
    const handleMouseLeaveSidebar = () => setIsCollapsed(true);

    const contextValue = {
        isCollapsed,
        setIsCollapsed,
        handleMouseEnterSidebar,
        handleMouseLeaveSidebar,
    };

    return (
        <SidebarContext.Provider value={contextValue}>
            {children}
        </SidebarContext.Provider>
    );
};

export const useSidebar = () => {
    const context = useContext(SidebarContext);
    if (context === null) {
        throw new Error('useSidebar must be used within a SidebarProvider');
    }
    return context;
};
